import { UserColumns } from '@/backend/features/authentication/shared';
import { Filter } from '@juvare/platform-shared/features/storage';
import { UserFilterData } from '../types/UserFilterData';

export function mapUserFilterData(data: UserFilterData): Filter<UserColumns>[] {
    const filter: Filter<UserColumns>[] = [];
    if (data.search) {
        filter.push({
            op: 'or',
            filter: [
                { op: 'contains', column: 'email', value: data.search },
                { op: 'contains', column: 'firstName', value: data.search },
                { op: 'contains', column: 'lastName', value: data.search },
            ],
        });
    }
    if (data.permissions && data.permissions.length > 0) {
        filter.push({
            op: 'contains',
            column: 'permissions',
            value: data.permissions,
        });
    }
    return filter;
}
